import axios, { AxiosInstance } from 'axios'

import { CompanyObjectTypeResponse } from '@repo/shared/types/company.types'

class CompanyService {
  private api: AxiosInstance

  constructor() {
    this.api = axios.create()

    this.api.interceptors.request.use((config) => {
      const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null
      if (token) {
        config.headers = config.headers || {}
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    })
  }

  getCompanies() {
    return this.api.get<CompanyObjectTypeResponse[]>('/api/company')
  }
}

export default new CompanyService()
